import { useContext } from "react";
import CompanySelector from "./CompanySelector";
import { ProductContext } from "./ProductForm";

const CompanyView = () => {
  const { product, setProduct } = useContext(ProductContext);

  return (
    <div className="card">
      <h5>Company</h5>
      <CompanySelector
        className="mt-2 w-full"
        value={product.company}
        onChange={(company) => setProduct((prev) => ({ ...prev, company }))}
      />
      <div className="mt-2 opacity-70">
        Note that a shared product in Odoo will have different data depends on
        the company. For example, the cost price and the supplier info can be
        different.
      </div>
    </div>
  );
};

export default CompanyView;
